import { gql } from "@apollo/client";

// We need to find a way to test these fragments in isolation

const DATA_PAIR_FRAGMENT = gql`
  fragment dataPair on DataPair {
    key
    value
  }
`;

const CONTENT_BLOCKS_FRAGMENT = gql`
  fragment contentBlocks on ContentBlock {
    ... on MarkdownBlock {
      id
      label
      textValue: value
    }
    ... on ImageBlock {
      id
      src
      altText
    }
    ... on BpCustomComponent {
      id
      customValue: value
    }
  }
`;

const ACTION_BLOCK_FRAGMENT = gql`
  fragment actionBlock on ActionBlock {
    primaryLabel
    primaryActionId
    secondaryLabel
    secondaryActionId
  }
`;

const MULTIPLE_CHOICE_OPTION_FRAGMENT = gql`
  fragment multipleChoiceOption on MultipleChoiceOption {
    id
    key
    label
    additionalTextMode
    additionalTextAttributes {
      ...dataPair
    }
  }
  ${DATA_PAIR_FRAGMENT}
`;

const BASE_STEP_FRAGMENT = gql`
  fragment baseStep on BaseStepType {
    id
    header
    metadata {
      ...dataPair
    }
    contentBlocks {
      ...contentBlocks
    }
    actions {
      ...actionBlock
    }
  }
  ${DATA_PAIR_FRAGMENT}
  ${CONTENT_BLOCKS_FRAGMENT}
  ${ACTION_BLOCK_FRAGMENT}
`;

const BINARY_CHOICE_STEP_FRAGMENT = gql`
  fragment binaryChoiceStep on BinaryChoiceStep {
    id
    header
    metadata {
      ...dataPair
    }
    contentBlocks {
      ...contentBlocks
    }
    actions {
      ...actionBlock
    }
    checkOption {
      ...dataPair
    }
  }
  ${DATA_PAIR_FRAGMENT}
  ${CONTENT_BLOCKS_FRAGMENT}
  ${ACTION_BLOCK_FRAGMENT}
`;

const MULTIPLE_CHOICE_STEP_FRAGMENT = gql`
  fragment multipleChoiceStep on MultipleChoiceStep {
    id
    header
    metadata {
      ...dataPair
    }
    contentBlocks {
      ...contentBlocks
    }
    actions {
      ...actionBlock
    }
    optionBlocks {
      ...multipleChoiceOption
    }
  }
  ${DATA_PAIR_FRAGMENT}
  ${CONTENT_BLOCKS_FRAGMENT}
  ${ACTION_BLOCK_FRAGMENT}
  ${MULTIPLE_CHOICE_OPTION_FRAGMENT}
`;

const RESULT_STEP_FRAGMENT = gql`
  fragment resultStep on ResultStep {
    id
    result
    title
    body
  }
`;

const STEP_FRAGMENT = gql`
  fragment step on Step {
    ...baseStep
    ...binaryChoiceStep
    ...multipleChoiceStep
    ...resultStep
  }
  ${BASE_STEP_FRAGMENT}
  ${BINARY_CHOICE_STEP_FRAGMENT}
  ${MULTIPLE_CHOICE_STEP_FRAGMENT}
  ${RESULT_STEP_FRAGMENT}
`;

const MEMBERSHIP_MANAGEMENT_FLOW_FRAGMENT = gql`
  fragment membershipManagementFlow on MembershipManagementFlowResponse {
    step {
      ...step
    }
  }
  ${STEP_FRAGMENT}
`;

export const MEMBERSHIP_MANAGEMENT_FLOW_MUTATION = gql`
  mutation membershipManagementFlow(
    $branchName: String!
    $preview: Boolean!
    $flow: String!
    $data: MembershipManagementSubmitData
  ) {
    membershipManagementFlow(
      branchName: $branchName
      preview: $preview
      flow: $flow
      data: $data
    ) {
      ...membershipManagementFlow
    }
  }
  ${MEMBERSHIP_MANAGEMENT_FLOW_FRAGMENT}
`;
